import { Fragment, useState, useEffect } from 'react';

import { Dialog } from 'primereact/dialog';

import { WrongInvoiceService as Service } from './WrongInvoiceService';
import { LoadingService } from '../../../AppLoading';

import { useToolbar } from '../../../shared/hooks/Toolbar';
import { useDataTable } from '../../../shared/hooks/DataTable';

import { useSign } from '../../../shared/component/Sign';

import { DialogCrup } from './component/DialogCrup';
import { DialogViewTransferLog } from './component/DialogViewTransferLog';
import { DialogSendEmailRequire } from '../../hoa-don/component/DialogSendEmailRequire';
import EventEmitter from '../../../utils/EventEmitter';
export const List = () => {

  const header = 'Thông báo 04/SS-HĐĐT';
  const dataKey = 'id';
  const [sendType, setSendType] = useState(4);
  const [displayCrup, setDisplayCrup] = useState(null);
  const [displayTransferLog, setDisplayTransferLog] = useState(false);
  const [displaySendEmail, setDisplaySendEmail] = useState(false);
  const [pdf, setPdf] = useState(null);
  const [displayPdf, setDisplayPdf] = useState(null);

  const types = [
    { value: 1, label: 'Thông báo của Người nộp thuế' },
    { value: 2, label: 'Thông báo của Người nộp thuế theo thông báo của Cơ quan thuế' }
  ];
  const statuses = [
    { value: 0, label: 'Chưa gửi' },
    { value: 1, label: 'Đã gửi' }
  ];

  const feedbacks = [
    { value: 1, label: 'Tiếp nhận' },
    { value: 2, label: 'Không tiếp nhận' },
    { value: 3, label: 'Chấp nhận' },
    { value: 4, label: 'Không chấp nhận' }
  ];

  const { render: renderDataTable, reloadLazyData, selectedItems, setSelectedItems } = useDataTable({
    header,
    dataKey,
    columns: [
      { field: 'type', header: 'Loại thông báo', minWidth: 180, matchMode: 'contains', filterType: 'dropdown', filterOptions: types, dataType: 'fromFilterOptions' },
      { field: 'dateCreate', header: 'Ngày lập', width: 110, dataType: 'date' },
      {
        field: 'status', header: 'Trạng thái gửi CQT', width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: statuses, dataType: 'custom', customCell(rowData: any): any {
          if (rowData.status != 0) {
            return <span className={`underline ss04-status ss04-status-${rowData.status}`} onClick={() => setDisplayTransferLog(true)}>{statuses[rowData.status]?.label}</span>;
          } else {
            return <span className={`ss04-status ss04-status-${rowData.status}`}>{statuses[rowData.status]?.label}</span>;
          }
        }
      },
      {
        field: 'taxAuthorityFeedback', header: 'Phản hồi CQT', width: 150, matchMode: 'contains', filterType: 'dropdown', filterOptions: feedbacks, dataType: 'custom', customCell(rowData: any): any {
          if (typeof rowData.taxAuthorityFeedback === 'number') {
            return <span className={`underline ss04-feedback ss04-feedback-${rowData.taxAuthorityFeedback}`} onClick={() => setDisplayTransferLog(true)}>{feedbacks[(rowData.taxAuthorityFeedback - 1)]?.label}</span>;
          } else {
            return '';
          }
        }
      },
      { field: 'documentNo', header: 'Số thông báo', width: 120, matchMode: 'contains' },
      { field: 'invoiceNo', header: 'Số hóa đơn', minWidth: 160, matchMode: 'contains' },
      { field: 'dateSign', header: 'Ngày gửi', width: 100, dataType: 'date' },
      {
        field: 'print', header: 'Xem in', width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-print" onClick={() => print(rowData)}></i>
        }, style: { justifyContent: 'center' }
      },
      {
        field: 'print', header: 'Gửi Email', width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="p-button-icon p-c pi pi-envelope" onClick={() => sendEmail(rowData)}></i>
        }, style: { justifyContent: 'center' }
      },
      {
        field: 'download', header: 'Tải XML', width: 70, sortable: false, dataType: 'custom', customCell(rowData: any): any {
          return <i className="pi pi-download" onClick={() => downloadXml(rowData)}></i>
        }, style: { justifyContent: 'center' }
      }
    ],
    indexColumnWidth: 40,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const { renderSign, sign } = useSign({ onComplete: reloadLazyData });

  const print = (rowData) => {
    setPdf(Service.getPdfUrl(rowData.id));
    setDisplayPdf(true);

    LoadingService.start();
  }

  const onIframeLoad = () => {
    LoadingService.stop();
  }

  const downloadXml = (rowData) => {
    Service.downloadXml(rowData.id).then(data => {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([data]));
      link.download = `${rowData['taxCode']}_04_ss-HDDT.xml`;
      link.click();
    });
  }
  const sendEmail = (item) => {
    setSelectedItems(item);
    setDisplaySendEmail(true);
  }

  {/* useEffect(() => {
    const reloadData = () => {
      reloadLazyData
    }
    const eventsListner = EventEmitter.addListener("reloadInvoiceData", reloadData);
    return () => {
      eventsListner.removeListener("reloadInvoiceData", reloadData);
    }
  }); */}
  const { renderToolbar } = useToolbar({
    dataKey,
    create: () => {
      setSelectedItems(null);
      setDisplayCrup(true);
    },
    update: () => {
      setDisplayCrup(true);
    },
    // update,
    // clone,
    reloadLazyData,
    selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    },
    otherActions: [
      {
        label: 'Ký gửi CQT', icon: 'pi pi-fw pi-user-edit', className: 'iam-toolbar', command: () => {
          if (selectedItems && selectedItems['id']) {
            sign({
              "CommandName": "SignSS04",
              "Id": selectedItems['id']
            });
          }
        }
      }
    ]
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderSign()}

      <DialogCrup display={displayCrup} setDisplay={setDisplayCrup} selectedItem={selectedItems} reloadLazyData={reloadLazyData} />
      <DialogViewTransferLog display={displayTransferLog} setDisplay={setDisplayTransferLog} selectedItem={selectedItems} />
      <Dialog header="Pdf" visible={displayPdf} style={{ width: '80rem' }} position="top"
        onHide={() => setDisplayPdf(false)}>
        {pdf &&
          <iframe className="template-preview" src={pdf} title="pdf-preview" onLoad={onIframeLoad} />
        }
      </Dialog>
      <DialogSendEmailRequire display={displaySendEmail} setDisplay={setDisplaySendEmail} sendType={sendType} selectedItems={selectedItems} />
    </Fragment>
  )
}
